// Shared @craft-form/renderer theme (passed as CraftFormProvider's `theme`
// prop) — mirrors this app's own palette (assets/scss/variables.scss) so the
// MUI-based renderer matches the surrounding bootstrap/SCSS themed pages.
// Every form migrated to @craft-form/renderer should reuse this, not redefine
// its own.
const craftFormTheme = {
  colors: {
    primary: "#405189", // $primary
    primaryContrast: "#ffffff", // $white
    secondary: "#3577f1", // $blue
    text: "#212529", // $black-secondary
    textMuted: "#878a99", // $grey-light
    background: "#ffffff", // $white
    inputBackground: "#ffffff", // $white
    surface: "#f3f3f9", // $primary-extralight
    border: "#e9ebec", // $white-tertiary
    borderStrong: "#ced4da", // $white-quaternary
    disabled: "#adb5bd",
    warning: "#ff8e3a", // $orange
    warningSurface: "#fff4ec",
    error: "#b91c1c", // $red-dark
    success: "#0ab39c", // $green
  },
};

export default craftFormTheme;
